<template>
  <div>
    <base-goods-action
      ref="cashier"
      v-model="showGoodsAction"
      goods-title="商品信息"
      goods-name-title="商品名称"
      :goods-name="goodsInfo && goodsInfo.title"
      goods-list-title="服务期限"
      :goods-list="goodsList"
      :payments="goodsInfo && goodsInfo.payments"
      :balance="balance.balance"
      :sale-remark="goodsInfo && goodsInfo.saleRemark"
      :sale-remark-append="goodsInfo && goodsInfo.saleRemarkAppend"
      :loading="loading"
      @pay="createOrder"
    >
      <template #goods="{ goodsItem }">
        <div class="set-name">{{ goodsItem.name }}</div>
        <div class="price">
          <span class="symbol">￥</span>{{ goodsItem.price }}
        </div>
      </template>
    </base-goods-action>
    <verify-payment-action
      v-model="showVerify"
      @showPaymentList="hideVerifyAction"
    >
    </verify-payment-action>
  </div>
</template>

<script>
import { createOrder, getGoods } from '@/api/order'
import { getUrlByPath } from '@/assets/js/utils'
import store from '@/store'
import { PaymentMethods } from '@/constant/PaymentMethods'
import BaseGoodsAction from '@/components/GoodsAction/BaseGoodsAction'
import VerifyPaymentAction from '@/components/GoodsAction/VerifyPaymentAction'

const orderListCached = new Map()

function orderCacheKey(productId, couponNos) {
  const tag =
    couponNos === null || couponNos === undefined
      ? 'null'
      : JSON.stringify(couponNos)
  return `${productId}\u0000${tag}`
}

export default {
  name: 'GoodsAction',
  components: { BaseGoodsAction, VerifyPaymentAction },
  data() {
    return {
      PaymentMethods,
      goods: {
        goodsId: '',
        setId: '',
        orderId: ''
      },
      loading: false,
      payMethod: 0,
      // 交易类型
      tradeType: 3,
      goodsList: null,
      showGoodsAction: false,
      /**
       * 商品信息
       * @type {GoodsInfo}
       */
      goodsInfo: null,
      /**
       * 订单信息
       * @type {OrderInfo}
       */
      orderInfo: null,
      showVerify: false
    }
  },
  created() {
    this.getBalance()
  },
  computed: {
    balance() {
      return store.state.user.balance
    }
  },
  watch: {
    showGoodsAction(val) {
      if (!val) {
        orderListCached.clear()
        this.showGoodsAction = false
        this.loading = false
      }
    }
  },
  methods: {
    show(goods) {
      this.goods = goods
      this.showGoodsAction = true
      this.showVerify = false

      this.getGoods()
    },
    hide() {
      orderListCached.clear()
      this.showGoodsAction = false
      this.loading = false
    },
    async getBalance() {
      store.dispatch('user/getBalance')
    },
    async getGoods() {
      const goodsId = this.goods.goodsId
      // setId等同于productId
      let setId = this.goods.setId
      const goodsInfo = await getGoods(goodsId, setId)

      if (goodsInfo) {
        this.goodsInfo = goodsInfo
        this.goodsList = goodsInfo.sets
        if (setId) {
          setId = parseInt(setId, 10)
          const idx = goodsInfo.sets.findIndex(item => item.id === setId)
          this.$nextTick(() => {
            if (this.$refs.cashier && idx >= 0) {
              this.$refs.cashier.setActiveIndex(idx)
            }
          })
        }

        const orderId = this.goods.orderId
        if (orderId) {
          const orderInfo = {
            orderId
          }
          const cacheKey = orderCacheKey(setId, null)
          orderListCached.set(cacheKey, orderInfo)

          this.orderInfo = orderInfo
        }
      } else {
        this.goodsInfo = 0
      }
    },
    /**
     * 创建订单
     * @return {Promise<void>}
     */
    async createOrder(productInfo) {
      const productId = productInfo.id
      this.payMethod = productInfo.payMethod
      this.tradeType = productInfo.tradeType
      const couponNos =
        productInfo.couponNos === undefined ? null : productInfo.couponNos
      const cacheKey = orderCacheKey(productId, couponNos)

      if (orderListCached.has(cacheKey)) {
        this.orderInfo = orderListCached.get(cacheKey)
        this.initiatePayment()
        return
      }

      this.loading = true
      var source = store.getters['auth/popularizeSource']

      const { result, detail } = await createOrder(
        productId,
        source,
        1,
        couponNos
      )
      if (result.code === 0) {
        orderListCached.set(cacheKey, detail)

        this.orderInfo = detail

        this.initiatePayment()
      } else {
        this.$toasted.show(result.msg || '订单创建失败', {
          position: 'bottom-center',
          duration: 3000
        })
        this.loading = false
      }
    },
    /**
     * 发起支付
     */
    initiatePayment() {
      const orderId = this.orderInfo.orderId
      const method = this.payMethod
      const tradeType = this.tradeType

      const child = window.open(
        getUrlByPath('cashier-desk', {
          orderId,
          method,
          tradeType,
          callback: encodeURIComponent(location.href),
          name: (window.name = 'yktpc')
        })
      )

      setTimeout(() => {
        this.loading = false
        this.showGoodsAction = false
        this.showVerify = true
      }, 500)

      child.removeEventListener('message', this.onPaymentStatus)
      child.addEventListener('message', this.onPaymentStatus)
    },
    onPaymentStatus(message) {
      console.info('onPaymentStatus:', message, this)
      if (message && message.data === true) {
        store.dispatch('right/getAllRightList')
        this.hide()
      }
    },
    hideVerifyAction() {
      this.showGoodsAction = true
      this.showVerify = false
    }
  }
}
</script>

<style lang="scss" scoped>
.set-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  color: #262626;
  line-height: 1;

  span {
    color: #046bcc;
  }
}

.price {
  padding-top: 12px;
  font-size: 20px;
  color: #e64c2e;
  line-height: 1;

  .symbol {
    font-size: 16px;
  }
}
</style>
